
import { mapGetters } from 'vuex'
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
import Flow from '@/components/im/Flow'
import SellerDetailsFastSell from '@/components/SellerDetails/fastSell.vue'
import { deleteFixedEnName, mappingFieldToStr } from '@/utils/validate'
import { orderStatusBySeller } from '@/enum/localEnum'
import VBus from '@/v-bus'
import { openWxFollow } from '@/settings'
import { formatCount } from '@/utils'
import { deepClone } from '@/utils'
import RightButtons from '@/components/PZRightButtons'
import FlashSale from '@/components/CSS/FlashSale.vue'
import GoodsSimpleMessage from '@/components/CSS/GoodsSimpleMessage.vue'

const SellerDetailsSetStand = () => import('@/components/SellerDetails/setStand')

export default {
    components: { TitleBox, TitleBox2, Flow, SellerDetailsFastSell , RightButtons, FlashSale, GoodsSimpleMessage },
    computed: {
        ...mapGetters({
            userInfo: 'user/userInfo',
            exposureNum: 'game/exposureNum'
        }),
        titleBoxLeftImg() {
            if (this.showEditGoods) {
                return 'https://oss.pzds.com/imgv2/edit.png'
            }
            return 'https://oss.pzds.com/imgv2/commodity.png'
        },
        showTimeByOrderStatus() {
            let label = null
            let value = null
            switch (this.detailsData.status) {
                case orderStatusBySeller.ONESELF_DOWN_STAND:
                    label = '下架时间'
                    value = this.detailsData.oneselfDownStandTime
                    break
                case orderStatusBySeller.FORCE_DOWN_STAND:
                    label = '下架时间'
                    value = this.detailsData.forceDownStandTime
                    break
                case orderStatusBySeller.VERIFY_FAIL:
                    label = '审核时间'
                    value = this.detailsData.verifyTime
                    break
                case orderStatusBySeller.BEAN_SOLD:
                    label = '成交时间'
                    value = this.detailsData.transactionTime
                    break
                case orderStatusBySeller.ON_STAND:
                    label = '上架时间'
                    value = this.detailsData.onStandTime
                    break
                // 待审核和交易中
                default:
                    label = '创建时间'
                    value = this.detailsData.createTime
                    break
            }
            return { label, value }
        },
        titleBoxText() {
            if (!this.detailsData) {
                return '商品详情'
            }
            if (this.showEditGoods) {
                return '编辑商品'
            }
            switch (this.detailsData.statusName) {
                case '待审核':
                    return '审核详情'
                default:
                    return '商品详情'
            }
        },
        shareEndTime() {
			return this.detailsData?.shareEndTime
        },
        rightButtons() {
            const obj = {
                coupon:{
                    text: '曝光券',
                    handler: this.goToSelectCoupon
                },
                customerService: {
                    text: '联系客服',
                    handler: this.customerService
                },
                increaseExposure: {
                    text: '增加曝光',
                    handler: this.exposureGoodsHandle
                },
                downGoods: {
                    text: '下架商品',
                    handler: () => this.updateGoodsStatusHandle(orderStatusBySeller.ONESELF_DOWN_STAND)
                },
                editPrice: {
                    text: '修改价格',
                    handler: this.goToEditPage
                },
                deleteGoods: {
                    text: '删除商品',
                    handler: this.deleteGoodsHandler
                },
                republish: {
                    text: '重新发布',
                    handler: () => { this.republishViseble = true }
                },
                republishNew: {
                    text: '重新发布',
                    handler: () => { this.republishNewViseble = true }
                },
                republishOther: {
                    text: '重新发布',
                    handler: () => { this.republishOtherViseble = true }
                },
                onGoods: {
                    text: '上架商品',
                    handler: () => this.updateGoodsStatusHandle(orderStatusBySeller.ON_STAND)
                },
                confirmEdit: {
                    text: '确认修改',
                    handler: this.updatePriceHandle
                },
                reSubmit: {
                    text: this.empowerTxet,
                    handler: this.onSubmit
                },
                reSubmitPwd: {
                    text: this.empowerTxet,
                    handler: this.userPdw
                }
            }

            let arr = [];
            switch(this.status) {
                case orderStatusBySeller.ON_STAND:
                    arr = this.onStandHandle(obj)
                    break;
                case orderStatusBySeller.WAIT_VERIFY:
                    arr = this.waitVerifyHandle(obj)
                    break;
                case orderStatusBySeller.FORCE_DOWN_STAND:
                    arr = this.forcedDownStandHandle(obj)
                    break;
                case orderStatusBySeller.VERIFY_FAIL:
                    arr = this.verifyFailHandle(obj)
                    break;
                case orderStatusBySeller.ONESELF_DOWN_STAND:
                    arr = this.onSelfDownStandHandle(obj)
                    break;
                case orderStatusBySeller.WAIT_PUBLISH:
                    arr = this.waitPublishHandle(obj)
                    break;
                default:
                    break;
            }

            return arr
        },
		goodsNumInfo () {
			// TODO: 这里的字段都不确定
			const { seenText, hots, status } = this.detailsData || {}
			const arr = []
			const see = {
				label: '曝光',
				value: seenText || 0 // 总浏览量
			}
			const hot = {
				label: '想要',
				value: hots
			}
			if(status === orderStatusBySeller.ON_STAND) {
				arr.push(see)
			}
			arr.push(hot)
			return arr.map(item => `${item.label} ${item.value}`).join('-')
		}
    },
    data() {
        return {
            realNameModelState: false,
            changePriceVisible: false,
			changePriceFormData: {
				price: ''
			},
			changePricePlaceholder: '',
			changePriceConfirmLoading: false,
			changePriceRules:{
				price: [
					{ required: true, message: '请输入修改价格', trigger: 'blur' },
					{ pattern: /^(0|[1-9]\d{0,7})(\.\d{1,2})?$/, message: '请输入正确的价格，最多两位小数', trigger: 'blur' }
				]
			},
			backCheck: false,
			income2: 0,
			serviceCharge2: 0,
            income: 0,
            serviceCharge: 0,
            /** 不再更新此字段 */
            showEditGoods: false, // 显示修改价格
            showFunction: false, // 显示描述盒子
            orderStatusBySeller,
            customerServiceObj: {},
            loading: true,
            goodsKey: null,
            goodsNo: null,
            gameId: null,
            goodsCatalogueId: null,
            orderFlow: {},
            detailsData: null,
            // orderDetailsData: null,
            goodsPrice: null,
            orderStatus: null,
            status: null,
            empowerTxet: '',
            ruleForm: {},
            releaseDataObj: {},
            qrCodeImg: '',
            republishViseble: false,
            republishOtherViseble: false,
            republishNewViseble: false,
            centerPayDialogVisible: false, // 支付方式
            centerPayQRDialogVisible: false, // 关闭支付提示
            parInfo: {}, // 创建订单回调信息
            articleDetail: {}, // 购买须知
            centerDialogVisible2: false, // 购买须知弹窗
            exposureCouponCount: 0,// 可用曝光劵数量
            countdownTime: ['00', '00', '00'],
			countdownTimer: null
        }
    },
    watch: {
        $route: {
            handler: function (route) {
                this.orderStatus = route.query && route.query.orderStatus
                if (route.query.reload) { this.onInit() }
            },
            immediate: true
        },
        'detailsData.price': {
            handler: throttle(function (newValue, oldVal) {
                if (newValue != oldVal) {
                    const { merchantDiscountAmount, gameId, goodsCatalogueId, goodsNo } = this.detailsData
                    const params = {
                        action: {
                            gameId,
                            goodsCatalogueId,
                            goodsPrice: Number(newValue),
                            goodsNo
                        }
                    }
                    const priceReg = new RegExp(/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/)
                    if (!priceReg.test(Number(newValue))) {
                        return
                    }
                    // 号商返现金额，后端可能返回 null，不能直接参与计算
                    const merchantDiscount = merchantDiscountAmount || 0
                    this.$api.getBargainFee(params).then(res => {
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.serviceCharge = res.data.serviceFee
                        // 卖家到手金额 = 商品价格 - 服务费 + 号商返现金额
                        this.income = parseFloat(Number(newValue) - res.data.serviceFee + merchantDiscount).toFixed(2)
                    })
                }
            }, 500), // 节流时间间隔200毫秒
            deep: true // 深度监听
        },
		'changePriceFormData.price': {
            handler: throttle(function (newValue, oldVal) {
                if (newValue != oldVal) {
					this.backCheck = false
                    const params = {
                        action: {
                            gameId: this.detailsData.gameId,
                            goodsCatalogueId: this.detailsData.goodsCatalogueId,
                            goodsPrice: Number(newValue),
                            goodsNo: this.detailsData.goodsNo
                        }
                    }
					if (params.action.goodsPrice === 0) return
                    const priceReg = new RegExp(/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/)
                    if (!priceReg.test(Number(newValue))) {
                        return
                    }
                    this.$api.getBargainFee(params).then(res => {
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
						this.backCheck = true
                        this.serviceCharge2 = res.data.serviceFee
                        this.income2 = parseFloat(Number(newValue) - res.data.serviceFee).toFixed(2)
                    })
                }
            }, 500), // 节流时间间隔200毫秒
            deep: true // 深度监听
        }
    },
    mounted() {
        // await this.getCustomerServiceConfig()
        this.getQrCode()
        this.$store.dispatch('game/ExposureNum')
        this.getExposureCouponCount()
    },
    created() {
        if (!this.$route.query.reload) { this.onInit() }
    },
    methods: {
        // 计算倒计时
		calculateCountdown() {
			const now = new Date().getTime()
			const endTime = new Date(this.shareEndTime?.replace(/-/g, '/')).getTime()

			const diffMs = endTime - now

			if (diffMs <= 0) {
				// 倒计时结束
				this.countdownTime = ['00', '00', '00']
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer)
					this.countdownTimer = null
				}
				return
			}

			// 计算时分秒
			const totalSeconds = Math.floor(diffMs / 1000)
			const hours = Math.floor(totalSeconds / 3600)
			const minutes = Math.floor((totalSeconds % 3600) / 60)
			const seconds = totalSeconds % 60

			// 格式化为两位数
			this.countdownTime = [hours.toString().padStart(2, '0'), minutes.toString().padStart(2, '0'), seconds.toString().padStart(2, '0')]
		},
		startCountdown() {
			this.calculateCountdown() // 立即计算一次

			if (this.countdownTimer) {
				clearInterval(this.countdownTimer)
			}

			this.countdownTimer = setInterval(() => {
				this.calculateCountdown()
			}, 1000)
		},
		clearCountdownTimer() {
			if (this.countdownTimer) {
				clearInterval(this.countdownTimer)
				this.countdownTimer = null
			}
		},
		// 可用曝光劵数量
		async getExposureCouponCount() {
			try {
				const res = await this.$api.exposureCouponCount()
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.exposureCouponCount = res.data.availableCount
			} catch (error) {
				this.$message.error(error.message)
			}
		},
		// 去选择优惠券
		goToSelectCoupon() {
			this.$router.push({
				path: '/account/selectCoupon',
				query: {
					goodsNo: this.detailsData.goodsNo,
					gameId: this.detailsData.gameId
				}
			})
		},
		/**
		 * 打开连体号配置弹窗
		 */
		openConjoinedConfigPop() {
			const { goodsNo, goodsUnionNo, gameId } = this.detailsData
			this.$refs.conjoinedGoodsConfigPop.openDialog({ goodsNo, goodsUnionNo, gameId })
		},
		// 重新发布逻辑判断
		async showRepublishViseble() {
			const par = {
				action: {
					gameId: this.detailsData.gameId,
					goodsCatalogueId: this.detailsData.goodsCatalogueId,
					isXiaomiTransfer: this.detailsData.isXiaomiTransfer,
					single1: this.detailsData.single1,
					single2: this.detailsData.single2,
					single3: this.detailsData.single3
				}
			}
			const res = await this.$api.postPrePropertyOptions(par)
			if (!res.success) {
				return
			}
			let shotTypeStatus = false
			if (res.data[0] && res.data[0].options) {
				const optionData = res.data[0].options
				shotTypeStatus = optionData.filter(el => el.key === this.detailsData.shotType).length > 0
			}
			console.log(shotTypeStatus, '111111！！！')

			if (shotTypeStatus) {
				this.republishViseble = true
			} else {
				this.republishOtherViseble = true
			}
		},
		// 去回收
        async recovery() {
            await this.$store.dispatch('user/UserGetInfo')
            if (!this.userInfo?.isRealName) {
                this.realNameModelState = true
                return
            }
            const val = this.detailsData
            this.$trackEvent({
                eventType: 'click',
                trackParams: {
                    eventName: '回收-去回收',
                    gameId: val.gameId,
                    goodsNo: val.goodsNo
                }
            })
            this.$router.push({
                name: 'servicesList',
                params: {
                    id: val.gameId,
                    name: val.gameIdName,
                    goodsCatalogueId: 6,
                    buyType: 'RECOVERY',
                    type: 1,
                    pageAccessSource:3
                }
            })
		},
		async onInit() {
			this.$store.dispatch('ry/setOrderFlow', [])
			this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
			this.$store.dispatch('AppPublicConfig')
			this.goodsNo = this.$route.query.goodsNo
			this.gameId = this.$route.query.gameId
			this.goodsCatalogueId = this.$route.query.goodsCatalogueId || 6
			await this.getSellerCenterGoodsOrderDetails()
			await this.getDataKey()
		},
		showIm() {
			const { orderNo, title, goodsImg, gameIdName, createTime } = this.detailsData
			const { name, transactionPrice, orderTypeName, orderStatus } = this.orderFlow
			this.$store.dispatch('ry/setOrderFlow', this.orderFlow.orderFlow)
			this.$store.dispatch('ry/setOrderGoods', { orderNo, title, goodsImg, gameIdName, orderTypeName, statusName: orderStatus, createTime, transactionPrice, compensationName: name })
			this.$store.commit('ry/SET_ORDER_FLOW_SHOW', true)
			this.$store.dispatch('ry/join', { targetId: this.detailsData.imGroupId, conversationType: 3 })
		},
		// 根据订单编号id 获取订单记录
		getOrderInfoFlow() {
			if (!this.detailsData.orderTemplateId || this.detailsData.orderNo.startsWith('DJ')) {
				if (!this.detailsData.orderNo) {
					return
				}
				this.$api.getOrderFlow({ orderNo: this.detailsData.orderNo }).then(res => {
					if (res.success) {
						this.orderFlow = res.data
					} else {
						this.orderFlow.orderFlow = []
					}
				})
			} else {
				this.$api.workorderOrderProcess({ orderId: this.detailsData.orderId }).then(res => {
					if (res.success) {
						if (!res.data.length) {
							return
						}
						let _arr = res.data
						_arr = this.renameKey(_arr, 'childNodeVOList', 'orderFlow')
						_arr = this.renameKey(_arr, 'pname', 'name')
						this.orderFlow.orderFlow = _arr
					}
				})
			}
		},
		renameKey(arr, oldKey, newKey) {
			return arr.map(obj => {
				if (oldKey in obj) {
					obj[newKey] = obj[oldKey] // 将旧的 key 的值赋给新的 key
					delete obj[oldKey] // 删除旧的 key
				}
				return obj
			})
		},
		filters(list) {
			const arr = []
			list.forEach(item => {
				if (item.orderFlow && item.orderFlow.length != 0) {
					arr.push(item)
				}
			})
			return arr
		},
		mappingFieldToStrHandle(detailsData, item) {
			return mappingFieldToStr(detailsData, item)
		},
		back() {
			if (this.showEditGoods) {
				this.$confirm('请确定是否放弃本次商品编辑结果？', '提示', {
					confirmButtonText: '确定',
					confirmButtonClass: 'confirmButtonClass',
					type: 'error'
				})
					.then(() => {
						this.showEditGoods = false
						this.getSellerCenterGoodsOrderDetails()
					})
					.catch(() => {})
				return
			}
			this.$router.push({
				path: '/account/sellerList',
				query: { status: this.$route.query.status }
			})
		},
		/**
		 * 获取传给后台的key
		 */
		async getDataKey() {
			const p = {
				action: {
					gameId: this.gameId || this.detailsData.gameId,
					goodsCatalogueId: this.goodsCatalogueId,
					inSell: true
				}
			}
			const res = await this.$store.dispatch('game/GoodsKey', p)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			this.goodsKey = res.data.filter(item => item.fieldConfigType === 'BASE')
		},
		/**
		 * 删除包含的固定字段
		 */
		getGoodsTabs(data) {
			if (!data) {
				return
			}
			if (deleteFixedEnName(data).length) {
				this.showFunction = true
				return deleteFixedEnName(data)
			}
			this.showFunction = false
		},
		/**
		 * 商品详情
		 */
		async getSellerCenterGoodsOrderDetails() {
			const p = {
				action: {
					goodsNo: this.goodsNo
				}
			}
			const res = await this.$api.goodsGoodsDetails(p)
			this.loading = false
			if (!res.success) {
				this.loading = false
				this.$message.error(res.info)
				return
			}

            this.detailsData = res.data
            const goodsNoList = [{goodsNo:this.goodsNo,onStandTime:this.detailsData.onStandTime}]
            const params = { action: [...goodsNoList] }
            this.$api.getGoodsWantAndSeenNum(params).then(d=>{
                if(d.success && d?.data?.length){
                    const map = new Map(d.data.map(d => [d.goodsNo, d]))
                    this.detailsData.seenNum = map.get(this.goodsNo).seenNum || 0
                    this.detailsData.seenText = formatCount(map.get(this.goodsNo).seenNum || 0)
                }
            })
            // 测试数据
            // this.detailsData.goodsUnionNo = 'UNION_'

			if (res.data.status == 'TRADING' || res.data.status == 'BEAN_SOLD') {
				this.getOrderInfoFlow()
			}

            if (res.data.goodsImg) {
                this.detailsData.goodsImg = this.detailsData.goodsImg && this.detailsData.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
            }
            this.status = res.data.status
            this.ruleForm = res.data
            switch (res.data.waitPublishStatus) {
                case -1:
                    // 任务发布失败
                    switch (res.data.thirdShotFailStatus) {
                        case 1:
                            this.empowerTxet = '重新授权上号'
                            break
                        case 2:
                            this.empowerTxet = '重新提交账号密码'
                            break
                        case 3:
                            this.empowerTxet = '重新发布'
                            break
                    }
                    break
                case 1:
                    this.empowerTxet = '授权上号'
                    break
                default:
                    this.empowerTxet = '授权上号'
                    break
            }
        },
        /**
         * 订单详情
         */
        // getGoodsOrderDetailsData() {
        // 	let p = {
        // 		action: {
        // 			goodsNo: this.goodsNo
        // 		}
        // 	}
        // 	this.$api.getGoodsOrderDetails(p).then(res => {
        // 		if (!res.success) {
        // 			this.$message.error(res.info)
        // 			return
        // 		}
        // 		this.orderDetailsData = res.data
        // 	})
        // },
        /**
         * 前往编辑
         * 如果商品状态是上架或自行下架就只能修改价格
         */
        goToEditPage() {
            if (this.status === orderStatusBySeller.ON_STAND || this.status === orderStatusBySeller.ONESELF_DOWN_STAND) {
                const fn = () => {
					this.changePriceVisible = true
					this.changePriceFormData.price = ''
					this.changePricePlaceholder = `请输入修改价格，当前价格是:¥${this.detailsData.price}`
				}
                if (this.detailsData.goodsUnionNo && this.detailsData.goodsUnionNo !== 'UNION_') {
                    this.$confirm('当前商品为连体号，价格将会同步至关联账号', '提示', {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirmButtonClass',
                        type: 'error'
                    }).then(() => {
                        // this.showEditGoods = true
                        // this.$nextTick(() => {
                        //     this.$refs.goodsPrice.focus()
                        // })
						fn()
                    })
                    return
                }
                // this.showEditGoods = true
                        // this.$nextTick(() => {
                        //     this.$refs.goodsPrice.focus()
                        // })
						fn()
                return
            }
            this.showEditGoods = false
            if (openWxFollow && !this.userinfo.isOfficialAccount) {
                this.$nextTick(() => {
                    this.$refs.releaseDialog.dialogForWxFollow = true
                })
                return
            }
            this.$store.commit('game/SET_RELEASE_DATA', { ...this.detailsData })
            this.$store.commit('SET_EDITGOODS_STATE', true)
            this.$router.push({
                path: '/editAccount',
                query: {
                    goodsNo: this.goodsNo,
                    isXiaomiTransfer: this.detailsData.isXiaomiTransfer
                }
            })
        },
        /**
         * 检查是否被限制强制下架商品
         */
        async onCheckLimit() {
            const par = {
                action: {
                    userBizLimited: 'GOODS_FORCE_DOWN_STAND'
                }
            }
            const check = await this.$api.checkOrderLimit(par)
            if (!check.data) {
                this.$message.error(check.info)
                return false
            }
            return true
        },
        /**
         * 修改商品状态
         * 做下架、上架等操作
         */
        updateGoodsStatusHandle(status) {
            let message = '您确定要进行该操作吗？'
            const statusMap = {
                ON_STAND: '上架',
                ONESELF_DOWN_STAND: '下架'
            }
            if (this.detailsData.goodsUnionNo && this.detailsData.goodsUnionNo !== 'UNION_') {
                message = `当前商品为连体号，将会同步${statusMap[status]}关联商品`
            }
            const model = this.$pzDialog(
                {
                    width: '600px',
                    title: '提示',
                    component: SellerDetailsSetStand,
                    showFooter: false,
                    componentData: {
                        goodsDetails: this.detailsData,
                        msg: message
                    },
                    onConfirm: async e => {
                        const loading = this.$loading({
                            lock: true,
                            text: '处理中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        })
                        const p = {
                            action: {
                                goodsNo: this.goodsNo,
                                status
                            }
                        }
                        if (e?.checked) {
                            p.action.refundFeelRelieved = true
                        }
                        const check = await this.onCheckLimit()
                        if (!check) { return }

						this.$api.updateGoodsStatus(p).then(res => {
							loading.close()
							if (!res.success) {
								this.$message.error(res.info)
								return
							}
							this.$message.success(res.info)
							VBus.$emit('reload')
							this.$router.push({
								path: '/account/sellerList',
								query: { status: this.$route.query.status }
							})
						})
						model.remove()
					},
					onCancel: async () => {
						model.remove()
					}
				},
				this
			)
		},
		/**
		 * 删除
		 */
		deleteGoodsHandler() {
			let conformMsg = '您确定要删除该商品吗？'
			if (this.detailsData?.status === 'ONESELF_DOWN_STAND') {
				conformMsg = '确认后，当前商品将会删除，若您已购买极速卖权益，也将同步取消'
			}
			this.$confirm(conformMsg, '警告', {
				confirmButtonText: '确定',
				confirmButtonClass: 'confirmButtonClass',
				type: 'error'
			})
				.then(() => {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					})
					const p = {
						action: {
							goodsNo: this.goodsNo
						}
					}
					this.$api.deleteGoods(p).then(res => {
						loading.close()
						if (!res.success) {
							this.$message.error(res.info)
							return
						}
						this.$message.success(res.info)
						VBus.$emit('reload')
						this.$router.push({
							path: '/account/sellerList',
							query: { status: this.$route.query.status }
						})
					})
				})
				.catch(_ => {})
		},
		/**
		 * 商品所属客服链接
		 */
		getCustomerServiceConfig() {
			const p = {
				action: {
					gameId: this.gameId || this.detailsData.gameId,
					goodsCatalogueId: this.goodsCatalogueId
				}
			}
			this.$store.dispatch('game/CustomerServiceConfig', p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.customerServiceObj = res.data
			})
		},
		/**
		 * 联系客服
		 */
		customerService() {
			// if (!this.customerServiceObj) {
			//   this.$message.error("暂无客服链接");
			//   return;
			// }
			const _info = {
				action: {
					event: 'CONSULT_SERVICE_GAME',
					eventId: this.detailsData.gameId
				}
			}
			this.$api.getRelatedClicks(_info).then(res => {})

			const info = {
				action: {
					gameId: this.detailsData.gameId,
					goodsCatalogueId: this.detailsData.goodsCatalogueId,
					goodsNo: this.detailsData.goodsNo,
					linkType: 'AUDITFAILED'
				}
			}
			if (this.$route.query.status == 'WAIT_VERIFY' || this.$route.query.status == 'VERIFY_FAIL') {
				info.action.linkType = 'AUDITFAILED'
			}
			if (this.detailsData.status == 'WAIT_PUBLISH') {
				info.action.linkType = 'ACTIVITY_REWARD'
			}

			this.$api.getGoodsCustomerService(info).then(res => {
				if (!res.data) {
					this.$message({
						message: '暂无客服值班',
						type: 'error'
					})
					return
				}

				const goodsInformation = { goodsNo: this.detailsData.goodsNo, title: '我的商品咨询' }
				this.$store.dispatch('ry/sendGoodsMsg', { targetId: res.data.id, content: goodsInformation })
			})
			// if (e.imId) {
			//     this.$store.dispatch("ry/join", e.imId);
			// }
			//
			// if (thirdPartyServiceUrl) {
			//   thirdPartyServiceInfo(
			//     this.customerServiceObj.consultUrl,
			//     this.userinfo
			//   );
			//   return;
			// }
			// window.open(this.customerServiceObj.consultUrl);
		},
		/**
		 * 修改商品价格
		 * 只能在商品上架的时候
		 */
		updatePriceHandle() {
			if (!this.detailsData.price) {
				this.$message.error('商品价格不能为空')
				this.$refs.goodsPrice.focus()
				return
			}
			const p = {
				action: {
					gameId: this.gameId || this.detailsData.gameId,
					goodsCatalogueId: this.goodsCatalogueId,
					goodsNo: this.goodsNo,
					price: this.detailsData.price
				}
			}
			this.$api.updatePrice(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.$message.success(res.info)
				this.showEditGoods = false
			})
		},
		/**
		 * 增加商品曝光
		 */
		exposureGoodsHandle() {
			const loading = this.$loading({
				lock: true,
				text: '处理中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			const p = {
				action: {
					goodsNo: this.goodsNo
				}
			}
			this.$api.addGoodsTempHeat(p).then(res => {
				loading.close()
				// 埋点 是否放心购商品
				this.$store.dispatch('tracking/PointList', { event: this.detailsData.isConfidenceBuy ? 'GOODS_EXPOSURE_CONFIDENCE_BUY' : 'GOODS_EXPOSURE_NORMAL' })
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.$message.success(res.data.message)
			})
		},

		//  发布流程
		onSubmit() {
			if (this.ruleForm.shotType == 'THIRD_SHOT') {
				const data = {
					action: this.ruleForm
				}
				// this.$api.userCenterGoodsCheck(data).then(res => {
				// 	// 检查商品是否重复
				// 	if (res.success) {
				// 		// 校验是否通过
				// 		if (res.data.pass) {

				// 		} else {
				// 			if (res.data.sellerOwn) {
				// 				// 提示账号重复 true
				// 				this.$refs.empowerDialogRef.showType(true, 997)
				// 			} else {
				// 				// 提示账号重复 false
				// 				this.$refs.empowerDialogRef.showType(true, 996)
				// 			}
				// 		}
				// 	} else {
				// 		this.$message.error(res.info)
				// 	}
				// })
				// 通过
				switch (this.empowerTxet) {
					case '授权上号':
						this.$refs.empowerDialogRef.userCenterGoodsCheck(data, true, 1)
						break
					case '重新授权上号':
						this.$refs.empowerDialogRef.userCenterGoodsCheck(data, true, 1)
						break
					// case '重新提交账号密码':
					//     this.$refs.empowerDialogRef.userCenterGoodsCheck(data, true, 5)
					//     break
					case '重新发布':
						this.republishNewViseble = true
						break
				}
			}
		},
		userPdw() {
			const data = {
				action: this.ruleForm
			}

			this.$refs.empowerDialogRef.userCenterGoodsCheck(data, true, 5)
		},
		// 发布成功清空表单跳转至结果页
		saveGoodsResetFields(p) {
			// 重置表单数据
			this.$router.replace(`/success?goodsNo=${p.action.goodsNo}&gameId=${p.action.gameId}&goodsCatalogueId=${p.action.goodsCatalogueId}&buyType=${this.buyType}`)
			// 清空发布数据、发布面包屑
			setTimeout(() => {
				this.$store.commit('game/CLEAR_RELEASE_DATA', p.action.gameId)
				this.$store.commit('game/SET_RELEASE_BREADCRUMB', {})
			}, 300)
		},
		// 获取二维码
		getQrCode() {
			const data = {
				publicKey: 'WECHAT_OFFICIAL_GLOBAL_CONFIG'
			}
			this.$api.sysGetConfig(data).then(res => {
				if (res.data == 'TRUE') {
					this.$api.getBindingQrCodeUrl().then(res => {
						if (res.success) {
							this.qrCodeImg = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket
						}
					})
				}
			})
		},
		// 重新发布
		republish() {
			const par = {
				action: {
					goodsNo: this.detailsData.goodsNo
				}
			}
			// this.$api.deleteGoods(par).then(res => { })
			this.$store.commit('SET_EDITGOODS_STATE', false)
			let p = {
				gameId: this.detailsData.gameId,
				goodsCatalogueId: this.detailsData.goodsCatalogueId,
				gameName: this.detailsData.gameIdName,
				single1: this.detailsData.single1,
				single2: this.detailsData.single2,
				single3: this.detailsData.single3
			}
			this.$store.commit('game/SET_RELEASE_DATA', p)
			this.$router.push({
				path: '/editAccount',
				query: {
					goodsNo: this.detailsData.goodsNo
				}
			})
		},
		// 重选区服发布
		republishOther() {
			const p = {
				action: {
					goodsNo: this.detailsData.goodsNo
				}
			}
			this.$api.deleteGoods(p).then(res => {})
			this.$store.commit('SET_EDITGOODS_STATE', false)
			const game = {
				gameId: this.detailsData.gameId,
				goodsCatalogueId: this.detailsData.goodsCatalogueId,
				gameName: this.detailsData.gameIdName
			}
			this.$store.commit('game/SET_RELEASE_DATA', game)
			this.$router.push({
				path: '/selectServer'
			})
		},
		// 审核失败-待发布-重新发布-不删除商品 -编辑商品
		republishNew() {
			this.$store.commit('SET_EDITGOODS_STATE', true)

            const game = {
                gameId: this.detailsData.gameId,
                goodsCatalogueId: this.detailsData.goodsCatalogueId,
                gameName: this.detailsData.gameIdName,
                single1: this.detailsData.single1,
                single2: this.detailsData.single2,
                single3: this.detailsData.single3
            }
            this.$store.commit('game/SET_RELEASE_DATA', game)
            this.$router.push({
                path: '/selectServer',
                query: {
                    goodsNo: this.goodsNo
                }
            })
        },
        // 关闭支付方式弹窗
        closePayDialogVisible(done) {
            this.centerPayQRDialogVisible = true
            if (!this.centerPayQRDialogVisible) {
                done()
            }
        },
        // 退出支付方式
        closePayDialogOkVisible() {
            this.centerPayQRDialogVisible = false
            this.centerPayDialogVisible = false
            this.$refs.qrPay.closeDialogVisible()
            this.getSellerCenterGoodsOrderDetails()
        },
        // 支付成功回调
        paySuccess(payStatus, msg = '支付失败') {
            if (payStatus === 'PAY_SUCCESS') {
                this.$message.success('支付成功！')
                this.closePayDialogOkVisible()
            } else {
                this.centerPayDialogVisible = payStatus
                this.closePayDialogOkVisible()
            }
        },
        // 放心购创建支付订单
        serveOrderCreate(serviceType) {
            const data = {
                action: {
                    goodsNo: this.detailsData.goodsNo,
                    serviceType
                }
            }
            this.$api.serveOrderCreate(data).then(res => {
                if (res.success) {
                    this.parInfo = {
                        ...this.detailsData.confidenceBuyModule,
                        ...res.data,
                        goodsNo: this.detailsData.goodsNo
                    }
                    this.centerPayDialogVisible = true
                    this.$nextTick(() => {
                        this.$refs.qrPay.getQrCode()
                    })
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 服务订单待支付
        serveOrderWaitPay() {
            this.parInfo = {
                ...this.detailsData.confidenceBuyModule,
                goodsNo: this.detailsData.goodsNo
            }
            this.centerPayDialogVisible = true
            this.$nextTick(() => {
                this.$refs.qrPay.getQrCode()
            })
        },
        // 根据商品状态判断是否显示放心购
        checkState(state) {
            let _state = false
            switch (state) {
                case 'WAIT_PUBLISH':
                case 'WAIT_VERIFY':
                case 'ONESELF_DOWN_STAND':
                case 'ON_STAND':
                    _state = true
                    break
                default:
                    _state = false
                    break
            }
            return _state
        },
        // 查看放心购须知
        getNotice() {
            const data = {
                action: {
                    id: 44
                }
            }
            this.$api.getHagglingDetail(data).then(res => {
                if (res.success) {
                    this.articleDetail = res.data
                    this.centerDialogVisible2 = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 回复提交
        gotoSubmit(item) {
            this.$router.push({ path: '/recentConsultationSubmit', query: { goodsNo: item.goodsNo } })
        },
        countDowmEnd() {
            let timer = null
            timer = setTimeout(() => {
                clearInterval(timer)
                this.getSellerCenterGoodsOrderDetails()
            }, 1000)
        },
        /**
         * button 处理函数
         * */

        /** 上架状态 */
        onStandHandle(obj) {
            const arr = []
            const newObj = deepClone(obj);
             if(this.exposureCouponCount) {
                arr.push(newObj.coupon)
            }
            arr.push(newObj.customerService, newObj.increaseExposure, newObj.downGoods, newObj.editPrice);
            return arr
        },
        /** 待审核状态 */
        waitVerifyHandle(obj) {
            const arr = []
            const newObj = deepClone(obj);
            arr.push(newObj.customerService);
            return arr
        },
        /** 强制下架（已下架）状态 */
        forcedDownStandHandle(obj) {
            const arr = []
            const newObj = deepClone(obj);
            arr.push(newObj.customerService, newObj.deleteGoods);
            return arr
        },
        /** 审核失败状态 */
        verifyFailHandle(obj) {
            const arr = []
            const newObj = deepClone(obj);
            arr.push(newObj.customerService,  newObj.republishNew, newObj.deleteGoods);
            return arr
        },
        /** 自行下架状态 */
        onSelfDownStandHandle(obj) {
            const arr = []
            const newObj = deepClone(obj);
            arr.push( newObj.customerService, newObj.republish, newObj.onGoods, newObj.editPrice, newObj.deleteGoods);
            return arr
        },
        /** 待发布状态 */
        waitPublishHandle(obj) {
            const arr = []
            const newObj = deepClone(obj);
            arr.push(newObj.customerService, newObj.deleteGoods);
            if (this.empowerTxet != '重新提交账号密码') {
                arr.push(newObj.reSubmit)
            } else {
                arr.push(newObj.reSubmitPwd)
            }
            return arr
        },
		async handlerConfirmChangePrice() {
			if(this.changePriceConfirmLoading) return
			await this.$refs.changePriceForm.validate()
			if(!this.backCheck) {
				this.$message.error('请输入正确的价格')
				return
			}

			const p = {
                action: {
                    gameId: this.gameId || this.detailsData.gameId,
                    goodsCatalogueId: this.goodsCatalogueId,
                    goodsNo: this.goodsNo,
                    price: this.changePriceFormData.price
                }
            }
			this.changePriceConfirmLoading = true
            this.$api.updatePrice(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.$message.success(res.info)
                this.changePriceVisible = false
				this.onInit()
            }).finally(() => {
				this.changePriceConfirmLoading = false
			})
		},
		resetChangePriceForm() {
			this.$refs.changePriceForm.resetFields()
		}
    },
    unmounted() {
		this.clearCountdownTimer()
	}
}
// 节流
function throttle(func, wait) {
	let timeout = null
	let lastExecution = 0
	return function (...args) {
		const context = this
		const now = Date.now()
		if (lastExecution && now - lastExecution < wait) {
			clearTimeout(timeout)
			timeout = setTimeout(() => {
				lastExecution = now
				func.apply(context, args)
			}, wait - (now - lastExecution))
		} else {
			lastExecution = now
			func.apply(context, args)
		}
	}
}
